import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { GreenTimeLogo } from '../components/Layout';
import { api } from '../services/api';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) return setError('Passwords do not match');
    if (password.length < 8) return setError('Password must be at least 8 characters');
    setLoading(true);
    try {
      await api.resetPassword(token, password);
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f4f1eb', display: 'flex',
                  alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
            <GreenTimeLogo size={48} />
            <h1 style={{ fontSize: 28, color: '#0d2b1a', fontFamily: "'Playfair Display', serif" }}>
              Green<span style={{ color: '#2e7d4f' }}>time</span>
            </h1>
          </div>
        </div>
        <div className="card">
          {!token ? (
            <div style={{ textAlign: 'center', padding: '1rem 0' }}>
              <p style={{ color: '#cc2200' }}>Invalid reset link.</p>
              <button onClick={() => navigate('/auth')}
                style={{ marginTop: 12, fontSize: 12, color: '#2e7d4f', background: 'none', border: 'none', cursor: 'pointer' }}>
                Back to sign in
              </button>
            </div>
          ) : done ? (
            <div style={{ textAlign: 'center', padding: '1rem 0' }}>
              <div style={{ fontSize: 28, marginBottom: 8 }}>✅</div>
              <p style={{ fontSize: 14, color: '#0d2b1a', fontWeight: 500 }}>Password updated!</p>
              <button onClick={() => navigate('/auth')} className="btn btn-accent"
                style={{ marginTop: 16, width: '100%', justifyContent: 'center' }}>
                Sign in
              </button>
            </div>
          ) : (
            <>
              <h3 style={{ fontSize: 16, color: '#0d2b1a', marginBottom: 4 }}>Choose a new password</h3>
              <form onSubmit={submit}>
                <div className="form-group">
                  <label className="form-label">New password</label>
                  <input className="form-input" type="password" value={password}
                         onChange={e => setPassword(e.target.value)} placeholder="••••••••" minLength={8} required />
                </div>
                <div className="form-group">
                  <label className="form-label">Confirm password</label>
                  <input className="form-input" type="password" value={confirm}
                         onChange={e => setConfirm(e.target.value)} placeholder="••••••••" minLength={8} required />
                </div>
                {error && <p className="form-error">{error}</p>}
                <button type="submit" className="btn btn-accent"
                  style={{ width: '100%', marginTop: '0.5rem', justifyContent: 'center' }} disabled={loading}>
                  {loading ? 'Updating…' : 'Update password'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
